if (!customElements.get('brand-cart-upsells')) {
  customElements.define('brand-cart-upsells', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', (event) => {
        const select = event.target.closest('[data-upsell-variant]');
        if (!select) return;
        const card = select.closest('.brand-cart-upsell-card');
        const option = select.selectedOptions[0];
        card.querySelector('[data-upsell-price]').textContent = option.dataset.price;
        const compare = card.querySelector('[data-upsell-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
      }, options);
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-upsell-add]');
        if (!button || button.disabled || this.pending) return;
        const card = button.closest('.brand-cart-upsell-card');
        const select = card.querySelector('[data-upsell-variant]');
        const variantId = select?.value || button.dataset.variantId;
        const page = this.closest('.brand-cart-page');
        const status = page.querySelector('[data-brand-cart-status]');
        const originalLabel = button.textContent;
        const addedLabel = this.dataset.added;
        const root = window.Shopify.routes.root;
        const dawn = this.dataset.engine === 'dawn';
        const sections = dawn ? [
          {id:'main-cart-items', section:document.getElementById('main-cart-items').dataset.id, selector:'.js-contents'},
          {id:'main-cart-footer', section:document.getElementById('main-cart-footer').dataset.id, selector:'.brand-cart-content'},
          {id:'cart-icon-bubble', section:'cart-icon-bubble', selector:'.shopify-section'},
          {id:'cart-live-region-text', section:'cart-live-region-text', selector:'.shopify-section'}
        ] : [];
        this.pending = true;
        this.querySelectorAll('[data-upsell-add]').forEach((add) => { add.disabled = true; });
        button.textContent = this.dataset.adding;
        status.textContent = '';
        let didAdd = false;
        try {
          const body = { items: [{ id: Number(variantId), quantity: 1 }] };
          if (dawn) {
            body.sections = sections.map((section) => section.section);
            body.sections_url = window.location.pathname;
          }
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || this.dataset.error);
          didAdd = true;
          if (dawn) {
            const updates = sections.map((section) => {
              const html = data.sections?.[section.section];
              if (!html) throw new Error('Cart section unavailable');
              const parsed = new DOMParser().parseFromString(html, 'text/html');
              const source = parsed.querySelector(section.selector);
              const parent = document.getElementById(section.id);
              const target = parent?.querySelector(section.selector) || parent;
              if (!source || !target) throw new Error('Cart section unavailable');
              return { source, target };
            });
            updates.forEach(({source,target}) => { target.innerHTML = source.innerHTML; });
            document.querySelector('.brand-cart-page [data-brand-cart-status]').textContent = addedLabel;
            fetch(`${root}cart.js`).then((result) => result.json()).then((cartData) => {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source:'cart-items', cartData, variantId:Number(variantId) });
              }
            }).catch(() => {});
          } else {
            status.textContent = addedLabel;
            document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
          }
        } catch (error) {
          if (didAdd) { window.location.reload(); return; }
          status.textContent = error.message || this.dataset.error;
        } finally {
          this.pending = false;
          this.querySelectorAll('[data-upsell-add]').forEach((add) => { add.disabled = false; });
          button.textContent = originalLabel;
        }
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
